'use client'

import Link from 'next/link'

import { Box, styled } from '@mui/material'
import { TreeItem } from '@mui/x-tree-view/TreeItem'

export const ProductTreeItem = styled(TreeItem)(({ theme }) => ({
  padding: 0,

  '.MuiTreeItem-content, .MuiTreeItem-content:hover, .MuiTreeItem-content.Mui-selected, .MuiTreeItem-content.Mui-selected:hover, .MuiTreeItem-content.Mui-focused, .MuiTreeItem-content.Mui-selected.Mui-focused':
    {
      padding: 0,
      backgroundColor: theme.palette.background.default,
      cursor: 'default',
    },
  '.MuiTreeItem-content .MuiTreeItem-iconContainer': { display: 'none' },
  '.Mui-expanded .MuiSvgIcon-fontSizeMedium ': { transform: 'rotate(-90deg)' },
}))
export const ProductTreeItemLabel = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  alignContent: 'flex-start',
  textDecoration: 'none',
  color: theme.palette.text.primary,
  ':hover': { color: theme.palette.text.primary, cursor: 'pointer', textDecoration: 'underline' },
}))
export const ProductTreeItemList = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  alignContent: 'flex-start',
  justifyContent: 'flex-start',
})
